import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { pushNotification } from "features/notificationSlice";
import { useAppDispatch } from "features/store";

/** Small copy-to-clipboard icon button with the standard "Copied." toast. */
export default function CopyButton({
  value,
  label = "Copy",
}: {
  value: string;
  label?: string;
}) {
  const dispatch = useAppDispatch();
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        sx={{ p: 0.25 }}
        onClick={() => {
          navigator.clipboard?.writeText(value);
          dispatch(
            pushNotification({ severity: "success", message: "Copied." }),
          );
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
}
